module.exports = {"510107001":"浆洗街街道","510107004":"望江路街道","510107005":"玉林街道","510107006":"跳伞塔街道","510107007":"火车南站街道","510107008":"双楠街道","510107009":"晋阳街道","510107010":"红牌楼街道","510107011":"簇桥街道","510107012":"机投桥街道","510107013":"金花桥街道","510107014":"簇锦街道","510107015":"华兴街道","510107061":"芳草街道","510107062":"肖家河街道","510107063":"石羊场街道","510107064":"桂溪街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510107.json
// module id = 2256
// module chunks = 0